angular.module('components.media.audio', [
  'stack',
  'components.media.AudioController'
])

/**
 * The componentAudio provides a preview
 * of the audio item type
 *
 * @class componentAudio
 * @constructor
 * @module components.media.audio
 * @example
 *   <component-audio
 *     model="form.model">
 *   </component-audio>
 */
.directive('componentAudio', [
  function () {
    'use strict';

    return {
      restrict: 'E',
      replace: true,
      scope: {
        model: '='
      },
      templateUrl: 'components/media/audio/audio.html',
      controller: 'AudioController'
    };
  }
]);
